import {
    CHEAPEST_FLIGHT_UPDATE,
    FLIGHTS_COUNT_UPDATED,
    FLIGHTS_IMPORT_END,
    GO_TO_PAGE,
    PARENT_FILTERS_CHANGED,
    PER_PAGE,
    RECOMMENDED_FLIGHT_UPDATE,
    REFRESH_FLIGHTS,
    RENDER_NEXT_PAGE,
    SOCKET_FILTER_RESPOND,
    TOGGLE_OVERLAY
} from "../../actions/FlightsActions";

export const AMOUNT_DISPLAY_OVERCHARGED = 'overcharged';

const initialState = {
    flights: [],
    loading: true,
    loadedPage: 1,
    viewPage: 1,
    count: 0,
    importEnded: false,
    cheapest: [],
    recommended: null,
    overlaying: {
        toggle: false,
        start: 0,
        delay: null
    },
    hadResults: null,
    cachedResults: false
};

const FlightsReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECOMMENDED_FLIGHT_UPDATE:
            return {
                ...state,
                recommended: action.data
            };
        case FLIGHTS_COUNT_UPDATED:
            let hadResults = state.hadResults;

            if (action.payload.count > 0) {
                hadResults = true;
            }

            if (action.payload.force) {
                return {...state, count: action.payload.count, hadResults};
            }

            return {...state, count: (state.count + action.payload.count), hadResults};
        case RENDER_NEXT_PAGE:
            const nextPage = parseInt(state.loadedPage, 10) + 1;
            return {
                ...state,
                loadedPage: nextPage,
                viewPage: nextPage,
            };
        case GO_TO_PAGE:
            return {
                ...state,
                viewPage: action.page,
            };
        case SOCKET_FILTER_RESPOND:
            const loaded = Math.ceil(action.payload.data.length / PER_PAGE) || 1;
            return {
                ...state,
                flights: action.payload.data,
                loading: false,
                viewPage: Math.min(state.viewPage, loaded),
            };
        case FLIGHTS_IMPORT_END:
            let loading = state.loading;
            if (action.data === 'no results') {
                loading = false;
            }

            return {
                ...state,
                importEnded: true,
                cachedResults: action.data.cachedResults,
                loading
            };
        case CHEAPEST_FLIGHT_UPDATE:
            return {
                ...state,
                cheapest: action.data
            };
        case PARENT_FILTERS_CHANGED:
            return {
                ...state,
                loadedPage: action.filters.page,
            };
        case TOGGLE_OVERLAY:
            return {
                ...state, overlaying: {
                    toggle: action.toggle,
                    start: (!action.toggle || action.delay) ? state.overlaying.start : (+new Date())
                }
            };
        case REFRESH_FLIGHTS:
            return {
                ...state,
                importEnded: false,
                overlaying: {toggle: action.toggle, start: action.delay ? state.overlaying.start : (+new Date())}
            };
        default:
            return state
    }
};

export default FlightsReducer;



// WEBPACK FOOTER //
// ./src/reducers/flights/FlightsReducer.js